import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material/";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DangerouslyHtml from "src/components/common/DangerouslyHtml/DangerouslyHtml";
import styled from "./styled";
import { useRouter } from "next/router";

interface ListProps {
  title: string;
  description: string;
  id: string;
  isLargeScreenDown: boolean;
}

const SpecificationAccordionItem: React.FC<ListProps> = ({
  title,
  description,
  id,
  isLargeScreenDown,
}) => {
  const { query } = useRouter();

  const [isExpanded, setExpanded] = useState<boolean>(
    query.withSideEffects === "true" && id === "sideEffects"
  );

  const handleChange = () => () => {
    setExpanded((prevState) => !prevState);
  };

  return (
    <Accordion
      disableGutters
      square
      sx={styled.root}
      expanded={isLargeScreenDown || isExpanded}
      onChange={handleChange()}
    >
      <AccordionSummary
        sx={styled.content}
        expandIcon={!isLargeScreenDown && <ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id={id}
      >
        <Typography fontWeight="500" variant="h4" component="h4">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styled.textDetail}>
        <DangerouslyHtml innerHtml={description} />
      </AccordionDetails>
    </Accordion>
  );
};

export default SpecificationAccordionItem;
